import { find, filter, remove, reduce, isEmpty, concat } from 'lodash';
var state = {
    items: [],
    itemBundle: {},
    itemOptions: {},
    currentGroups: {},
    currentBundle: {},
    currentGroupId: 0,
};
var getters = {
    items: function (state) {
        return state.items;
    },
    itemBundle: function (state) {
        return state.itemBundle;
    },
    currentBundle: function (state) {
        return state.currentBundle;
    },
    getGroups: function (state) {
        return state.currentGroups;
    },
    getChoicesForOption: function (state) { return function (itemId, optionId) {
        var option = state.itemOptions[itemId];
        if (!option) {
            return null;
        }
        var choices = option[optionId];
        return choices;
    }; },
    optionsForItem: function (state) { return function (itemId) {
        var group = state.currentGroups[state.currentGroupId];
        if (!group) {
            return null;
        }
        var options = find(group.options, function (option) {
            return option.asset_id === itemId;
        });
        return options;
    }; },
    itemSelectedInGroup: function (state) { return function (_a) {
        var itemId = _a.itemId, groupId = _a.groupId;
        var matchedItems = [];
        matchedItems = filter(state.items, function (item) {
            var inGroup = (item.parentGroupId === groupId);
            var matchingItem = (item.id === itemId);
            return inGroup && matchingItem;
        });
        return (matchedItems.length > 0);
    }; },
    groupRequirementsMet: function (state) { return function (groupId) {
        if (isEmpty(state.currentBundle) || (state.items.length === 0)) {
            return true;
        }
        var groups = state.currentBundle.groups;
        var bundleGroup = find(groups, function (group) {
            return group.id === groupId;
        });
        if (!bundleGroup) {
            return false;
        }
        var requiredCount = reduce(groups, function (accumulator, group) {
            return accumulator + group.requiredCount;
        }, 0);
        return (requiredCount === state.items.length);
    }; },
    // TODO too much data logic within the store, move into models
    allRequirementsMet: function (state, getters) {
        if (state.items.length === 0) {
            return false;
        }
        var bundle = state.currentBundle;
        if (!bundle) {
            return;
        }
        var groups = state.currentBundle.groups;
        for (var group in groups) {
            if (groups.hasOwnProperty(group)) {
                var groupId = groups[group].id;
                // Guard against meta data.
                if (!groupId) {
                    continue;
                }
                var requirementsMet = getters.groupRequirementsMet(groupId);
                if (requirementsMet) {
                    continue;
                }
                return false;
            }
        }
        return true;
    },
    // TODO might have to remove this
    total: function (state, getters) {
        var items = state.items;
        var total = reduce(items, function (sum, item) {
            return sum + item.getItemTotal();
        }, 0);
        var bundleDiscount = getters.discount;
        // TODO different types process discounts differently
        if (!bundleDiscount) {
            return null;
        }
        var discountedTotal = total - bundleDiscount.amount;
        return discountedTotal;
    },
};
var actions = {
    setCurrentBundle: function (_a, bundle) {
        var commit = _a.commit;
        commit('setCurrentBundle', bundle);
    },
    setCurrentGroup: function (_a, groupId) {
        var commit = _a.commit;
        commit('setCurrentGroup', groupId);
    },
    addItem: function (_a, item) {
        var state = _a.state, commit = _a.commit;
        commit('addItemToGroup', {
            item: item,
            groupId: state.currentGroupId,
        });
    },
    addItemToGroup: function (_a, _b) {
        var commit = _a.commit;
        var item = _b.item, groupId = _b.groupId;
        commit('addItemToGroup', {
            item: item,
            groupId: groupId,
        });
    },
    setChoicesForOption: function (_a, _b) {
        var commit = _a.commit;
        var itemId = _b.itemId, optionId = _b.optionId, choices = _b.choices;
        commit('setChoicesForOption', {
            itemId: itemId,
            optionId: optionId,
            choices: choices,
        });
    },
    setItemBundle: function (_a, itemBundle) {
        var commit = _a.commit;
        commit('setItemBundle', itemBundle);
    },
    setItems: function (_a, items) {
        var commit = _a.commit;
        commit('setItems', items);
    },
    // TODO move to separate store
    setDiscount: function (_a, discount) {
        var commit = _a.commit;
        commit('setDiscount', discount);
    },
    clearItemOptions: function (_a) {
        var commit = _a.commit;
        commit('clearItemOptions');
    },
    clearItems: function (_a) {
        var commit = _a.commit;
        commit('clearItems');
    },
    clearGroup: function (_a, groupId) {
        var commit = _a.commit;
        commit('clearGroup', groupId);
    }
};
var mutations = {
    setCurrentBundle: function (state, bundle) {
        state.currentBundle = bundle;
        if (!bundle) {
            return;
        }
        state.currentBundle.groups.forEach(function (group) {
            state.currentGroups[group.id] = group;
        });
    },
    setCurrentGroup: function (state, groupId) {
        state.currentGroupId = groupId;
    },
    addItemToGroup: function (state, _a) {
        var item = _a.item, groupId = _a.groupId;
        item['parentGroupId'] = groupId;
        var group = state.currentGroups[groupId];
        var groupItems = filter(state.items, function (_item) {
            _item.selected = false;
            return _item.parentGroupId === groupId;
        });
        var remainingItems = state.items;
        if (group.requiredCount <= groupItems.length) {
            //remove an old item
            remainingItems = remove(remainingItems, function (_item) {
                return _item.parentGroupId !== groupId;
            });
            groupItems.shift();
            state.items = concat(remainingItems, groupItems);
        }
        state.items.push(item);
        state.items.forEach(function (_item) {
            _item.selected = true;
        });
    },
    setChoicesForOption: function (state, _a) {
        var itemId = _a.itemId, optionId = _a.optionId, choices = _a.choices;
        var itemOptions = state.itemOptions;
        var options = itemOptions[itemId];
        if (!options) {
            state.itemOptions[itemId] = {};
        }
        state.itemOptions[itemId][optionId] = choices;
    },
    setItemBundle: function (state, itemBundle) {
        state.itemBundle = itemBundle;
    },
    setItems: function (state, items) {
        state.items = items;
    },
    clearItemOptions: function (state) {
        state.itemOptions = {};
        state.currentGroups = {};
    },
    clearItems: function (state) {
        state.items.forEach(function (item) {
            item.selected = false;
        });
        state.items = [];
    },
    // TODO use an item "group interface"
    clearGroup: function (state, groupId) {
        state.items = filter(state.items, function (item) {
            return item.parentGroupId !== groupId;
        });
    },
};
export default {
    namespaced: true,
    state: state,
    getters: getters,
    actions: actions,
    mutations: mutations,
};



//////////////////
// WEBPACK FOOTER
// ./src/stores/modules/bundle.store.ts
// module id = null
// module chunks = 